import service from './api.services';

const cancelarImovel = async (form) => {
    const response = await service.post('/api/imovel/cancelar', form);
    return response.data;
};

const suspenderImovel = async (form) => {
    const response = await service.post('/api/imovel/suspender', form);
    return response.data;
};

const reverterSuspensaoImovel = async (form) => {
    const response = await service.post('/api/imovel/reverter-suspensao', form);
    return response.data;
};

export {
    cancelarImovel,
    suspenderImovel,
    reverterSuspensaoImovel
};
